import { render, staticRenderFns } from "./scoreDialog.vue?vue&type=template&id=cf38d8ea&scoped=true&"
import script from "./scoreDialog.vue?vue&type=script&lang=js&"
export * from "./scoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./scoreDialog.vue?vue&type=style&index=0&id=cf38d8ea&scoped=true&lang=css&"
import style1 from "./scoreDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf38d8ea",
  null
  
)

export default component.exports